<template>
  <div class="container">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
    <div id="carousel-container">
      <row container :gutter="12">
        <column :xs="12" :md="6" :xl="4" class="d-flex" v-for="(option, idx) in options" :key="idx">
          <div class="slide-container">
            <div class="logo">
              <img :src="option.insurance_company_logo" alt="" />
            </div>
            <div class="nome">{{ option.product_friendly }}</div>
            <div v-if="option.status === 'APROVADO' || option.status === 'PRE_APROVADO'">
              <div class="total" v-for="paymentMethod in option.payment_methods" :key="paymentMethod.type">
                <span class="payment-type" :style="{ backgroundColor: chatbotColors.sentMessage.bg }">{{ paymentMethod.type_friendly }}</span>
                <span class="valor-seguro">{{ paymentMethod.amount_installment_friendly }}</span>
                <small class="description-installment">{{ paymentMethod.description_installment }}</small>
                <small class="desconto" v-if="option.insurance_company === 'PORTO_SEGURO' && paymentMethod.type === 'CARTAO_DE_CREDITO' && paymentMethod.total_installments === 1">desconto de 10% aplicado</small>
                <div class="details" v-if="paymentMethod.with_entry !== null">
                  <strong>Com entrada:</strong> {{ paymentMethod.with_entry ? 'Sim' : 'Não' }}
                </div>
              </div>
            </div>
            <div class="status status-recusado" v-if="option.status === 'RECUSADO'">RECUSADO</div>
            <div class="status status-em-analise" v-if="option.status === 'EM_ANALISE'">EM ANÁLISE</div>
            <div class="status status-erro" v-if="option.status === 'ERROR'">ANÁLISE COM ERRO</div>
            <div class="biometria" v-if="option.status === 'PRE_APROVADO'">*Valor PRÉ-APROVADO<br>(necessário biometria para aprovação)</div>
            <div class="msg-pottencial" v-if="option.insurance_company === 'POTTENCIAL' && ['APROVADO', 'PRE_APROVADO'].includes(option.status)">*Sujeito ao limite de crédito aprovado!</div>
            <button
              type="button"
              :disabled="optionSelected"
              @click.prevent="selectOption(option)"
              class="botao"
              :style="{ borderColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.bg }"
              v-if="option.status === 'APROVADO' || option.status === 'PRE_APROVADO'"
            >
            CONTRATAR
          </button>
        </div>
      </column>

      <column :xs="12" :md="6" :xl="4" class="d-flex" v-if="loadingCalculos">
        <div class="slide-container loader">
          <Loading :chatbotColors="chatbotColors"></Loading>
        </div>
      </column>
    </row>
  </div>
</div>
</template>

<script>
import Pusher from 'pusher-js';
import Loading from '../components/Loading'
import escapeGoat from 'escape-goat'
import store from "./../store/"

let pusher;

export default {
  components: {
    Loading
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
      optionSelected: null,
      options: [],
      loadingCalculos: true,
      attemptSeconds: 200
    }
  },
  computed: {
    messageText() {
      const escaped = this.me
      ? escapeGoat.escape(this.message.data.text)
      : this.message.data.text;

      return escaped;
    }
  },
  mounted () {
    Pusher.logToConsole = true;

    pusher = new Pusher('83ca3679560bbfbbe38e', {
      cluster: 'us2'
    });

    const channel = pusher.subscribe('conversa-' + this.$store.state.conversaToken);

    channel.bind('webhooks.fianca-received', ({ data }) => {
      this.options.push(data);
    });

    setTimeout(() => {
      pusher.disconnect();

      this.loadingCalculos = false;
    }, this.attemptSeconds * 1000);
  },
  methods: {
    selectOption (option) {
      pusher.disconnect();

      this.loadingCalculos = false;
      this.optionSelected = option;

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        bot: true,
        data: {
          key: null,
          text: `
            Contratar seguro fiança:
            <h2 style="margin-bottom: 0;">${option.insurance_company_friendly} ${option.product_friendly}</h2>
          `,
          metadata: option
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
a.chatLink {
  color: inherit !important;
}
.container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.d-flex {
  display: flex;
}
#carousel-container {
  width: 100%;
  margin-top: 10px;
}
.slide-container {
  width: 100%;
  min-height: 200px;
  padding: 21px;
  border-radius: 20px;
  background: #f1f1f1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &.loader {
    justify-content: center;
  }

  .logo {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-height: 70px;
    }
  }
  .nome {
    font-size: .9rem;
    text-align: center;
    color: #275145;
    margin-top: 10px;
  }
  .biometria {
    font-size: .7rem;
    font-weight: 500;
    text-align: center;
    color: #ff5645;
    margin-top: 10px;
  }
  .msg-pottencial {
    font-size: .7rem;
    font-weight: 500;
    text-align: center;
    color: #ff5645;
    margin-top: 10px;
  }
  .total {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    text-align: center;
    padding-bottom: 5px;
    border-radius: 10px;
    background: #f0faf9;
    color: #aaa;
    font-size: 0.8rem;
    overflow: hidden;

    .payment-type {
      display: block;
      color: white;
      font-size: 0.7rem;
      padding: 5px 0;
    }

    span.valor-seguro {
      font-size: 1.6rem;
      font-weight: 700;
      letter-spacing: -1px;
      color: green;
    }

    small.description-installment {
      font-size: .8rem;
      color: #333;
      font-weight: 600;
    }

    small.desconto {
      display: inline-block;
      align-self: center;
      margin: 5px 0;
      background: red;
      color: white;
      padding: 3px 8px;
      border-radius: 10px;
    }
  }
  .status {
    margin-top: 10px;
    text-align: center;
    padding: 5px;
    border-radius: 10px;
    overflow: hidden;
    color: white;
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: -1px;

    &.status-recusado,
    &.status-erro {
      background: #cb4538;
    }

    &.status-em-analise {
      background: #6638f0;
    }
  }
  .details {
    font-size: 0.8rem;
    color: #777;
    text-align: center;

    strong {
      font-weight: 600;
    }
  }
}

.botao {
  display: inline-block;
  padding: 8px 15px;
  border: 0;
  border-radius: 20px;
  font-size: 0.8rem;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  margin-top: 15px;
  border-width: 1px;
  border-style: solid;

  &:hover {
    opacity: .8;
  }

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
    pointer-events: all !important;
  }
}
</style>
